import { IdentityDto } from './../shared/identity.dto';

export class PropertyDto {
  name: IdentityDto;
  type: string;
  reference: string;
  value: string;

  constructor(d?: PropertyDto) {
    if (!d) {
      return;
    }
    this.name = new IdentityDto(d.name);
    this.type = d.type;
    this.reference = d.reference;
    this.value = d.value;
  }
}
